<template>
  <div
    class="user cursor-pointer"
    v-if="user && user.id"
    v-b-tooltip.hover
    :title="'Current user is ' + user.shortName"
  >
    User: {{ user.shortName }} - All times displayed in: <span class="text-uppercase">{{user.timeZone}}</span>
  </div>
</template>

<script lang="ts">
  import { UserDto } from '@/apiclient/apiclient_generated';
  import { UserModule, UserStore } from '@/store/user';
  import Vue from 'vue';
  import Component from 'vue-class-component';

  @Component({})
  export default class UserInfo extends Vue {
    private userStore: UserModule = UserStore;

    get user(): UserDto {
      return this.userStore.user;
    }
  }
</script>

<style scoped lang="scss">
  .user {
    border-radius: 5px;
    font-weight: bold;
    font-size: 0.9rem;
  }
</style>
